import { OpenAPI } from "../api/generated/core/OpenAPI";

export const initializeOpenAPI = (token?: string, email?: string) => {
  OpenAPI.BASE = 'https://app.seller2go.com';
  // OpenAPI.BASE = 'https://app.sandbox.seller2go.com';
  // OpenAPI.BASE = 'http://127.0.0.1:8085/api';
  // OpenAPI.BASE = 'http://localhost:8000';
  OpenAPI.WITH_CREDENTIALS = false;
  OpenAPI.CREDENTIALS = "omit";
  OpenAPI.TOKEN = token;

  const baseHeaders = {
    Accept: "*/*",
    "Content-Type": "application/json",
  };

  OpenAPI.HEADERS = baseHeaders;
};
